export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=2e09d060&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/services/index.vue?vue&type=template&id=2e09d060&
// module id = 1428
// module chunks = 0